
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';
import {useEvent} from "@hooks/useEvent"
import { addExtraSpace } from '../utils';

export const useCustomOffices = ({ containerKey, addData, updateData, deleteData})=>{
 const {isLoading,saveForm}=useEvent(containerKey)
 const dispatch = useDispatch();
  
 const addItem = useCallback(async(tableName,otherParams) => dispatch(addData({data:{id:Date.now()},meta:{tableName}})), []);

  const deleteItem = useCallback(async({id,tableName}) => dispatch(deleteData({id,meta:{tableName}})),[]);


  const saveItem = useCallback((tableName,payload,updateOtherFields={}) =>saveForm({[`${tableName}`]:[addExtraSpace(payload)],...addExtraSpace(updateOtherFields)},false), [saveForm]);
  const updateItem = useCallback((id,tableName,data) =>dispatch(updateData({id,data,meta:{tableName}})),[])
 
 const onSelect=useCallback(async(id,tableName,payload,updateOtherFields) => {
    try{
        updateItem(id,tableName,addExtraSpace(payload,true))
        saveItem(tableName,payload,updateOtherFields)
       
    }
    catch{

    }
 }, [saveItem,updateItem]);

  return {isLoading,addItem,deleteItem,onSelect,saveItem,updateItem}
}